export default "__VITE_ASSET__BmFgYg0m__"